import React from 'react'
import { Link, render } from 'react-router-dom'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import InstantSearch from "../../components/InstantSearch";
import { Segment, Grid } from "semantic-ui-react";

const Home = ({ data: { loading, error, allFaqTopics, _allFaqTopicsMeta } }) => {
  if (error) return <h1>Error fetching Faq Topics!</h1>
  if (!loading) {
    return (
      <div>

        {/* Instant Search */}
        <Segment>
          <InstantSearch />
        </Segment>

         {/* Results */}
        <Segment>
          <section>
            <ul className='Home-ul'>
              {allFaqTopics.map(faqTopic => (
                <div key={`faq-${faqTopic.id}`}>
                  <li className='Home-li'>
                    <Link to={`/faq-topic/${faqTopic.slug}`} className='Home-link'>
                      <div className='Home-placeholder'>
                      </div>
                      <h3>{faqTopic.topic}</h3>
                    </Link>
                  </li>

                  {faqTopic.faqs.map(faq => (
                    <Link to={`/faq/${faq.slug}`} className='' key={`faq-${faq.id}`}>
                      <h3 style={{
                        paddingBottom:'0.5em'
                      }}>{faq.question}</h3>
                    </Link>
                  ))}
                </div>
              ))}
            </ul>
          </section>
        </Segment>

      </div>
    )
  }
  return <h2>Loading posts...</h2>
}

export const allFaqTopics = gql`
  query {
      allFaqTopics{
        id
        topic
        slug
        faqs {
          id
          slug
          question
        }
      }
    ,
    _allFaqTopicsMeta{
      count
    }
  }
`

export default graphql(allFaqTopics, {})(Home)




// WEBPACK FOOTER //
// ./src/pages/Home/SectionHome.js